import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useEffect, useMemo, useState } from 'react'
import Select from 'react-select'
import { appGetAllSanstha } from '../../store/sanstha'
import ImageUpload from '../../components/ImageUpload'
import { appCreatePost, appGetAllPost, appUpdatePost } from '../../store/post'
import { uploadSponsorImage } from '../../store/sponsor'
import { EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import { ContentState } from 'draft-js'
import htmlToDraft from 'html-to-draftjs'
import draftToHtml from 'draftjs-to-html'
import { categoryOptions } from '../../common/jsonData'
import { toCamelCase } from '../../utils/Function'

function NewPost() {
	const { id } = useParams()
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const location = useLocation()
	const postFromRoute = location.state?.post

	const selectedPost = postFromRoute

	const Sanstha = useSelector(state => state.sansthaReducer.sanstha)
	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')
	const [editorValues, setValues] = useState(EditorState.createEmpty())

	const userData = JSON.parse(localStorage.getItem('user') || '{}')
	const userId = userData._id

	useEffect(() => {
		dispatch(appGetAllSanstha({ page: 1, limit: 1000, hub: hubId || permissionOfHub }))
	}, [dispatch, hubId, permissionOfHub])

	const onEditorStateChange = editorState => {
		formik.setFieldValue('description', draftToHtml(convertToRaw(editorState.getCurrentContent())))
		setValues(editorState)
	}

	useEffect(() => {
		if (selectedPost?.description) {
			const blocksFromHtml = htmlToDraft(selectedPost.description)
			const { contentBlocks, entityMap } = blocksFromHtml
			const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
			setValues(EditorState.createWithContent(contentState))
		}
	}, [selectedPost])

	const isCustomCategory =
		selectedPost?.category &&
		![
			'Announcement',
			'Inspiration',
			'Achievement',
			'Activity',
			'Photo Update',
			'Devotional',
			'Awareness',
		].includes(selectedPost.category)
	const formik = useFormik({
		initialValues: {
			title: selectedPost?.title || '',
			description: selectedPost?.description || '',
			hub: selectedPost?.hub?._id || hubId || permissionOfHub,
			sanstha: selectedPost?.sanstha?._id || '',
			file: selectedPost?.file || '',
			category: isCustomCategory ? 'Other' : selectedPost?.category || '',
			name: isCustomCategory ? selectedPost?.category : '',
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			description: Yup.string()
				.transform(value => {
					if (!value) return ''
					return value
						.replace(/<[^>]+>/g, '')
						.replace(/&nbsp;/gi, '')
						.replace(/\s+/g, '')
						.trim()
				})
				.test('is-not-empty', 'Description is Required', value => value && value.length > 0)
				.required('Description is Required'),
			title: Yup.string().required('Post title is required'),

			description: Yup.string()
				.transform(value => {
					if (!value) return ''
					return value
						.replace(/<[^>]+>/g, '')
						.replace(/&nbsp;/gi, '')
						.replace(/\s+/g, '')
						.trim()
				})
				.test('is-not-empty', 'Description is Required', value => value && value.length > 0)
				.required('Description is Required'),
			category: Yup.string().required('Category is required'),
			name: Yup.string().when('category', {
				is: 'Other',
				then: Yup.string().required('Please specify category'),
			}),
		}),
		onSubmit: values => {
			const temp_obj = {
				title: values.title,
				file: values?.file,
				description: values?.description,
				category: values?.category === 'Other' ? values.name : values.category,
				sanstha: values?.sanstha,
				hub: values?.hub,
				userId: userId,
				navigate: navigate,
			}
			const filtered_obj = Object.fromEntries(
				Object.entries(temp_obj).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)
			if (id) {
				dispatch(appUpdatePost({ ...filtered_obj, id })).then(() => {
					navigate('/post')
				})
			} else {
				dispatch(appCreatePost(filtered_obj)).then(() => {
					navigate('/post')
					formik.resetForm()
				})
			}
		},
	})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading">
					<div>
						<Link to="/native-place">Post</Link> / {id ? 'Edit Post' : 'New Post'}
					</div>
				</div>

				<div className="card card-default">
					<div className="card-body">
						<form onSubmit={formik.handleSubmit}>
							<div className="row mb-3">
								<div className="col-md-6">
									<label>Sanstha </label>
									<Select
										options={
											Array.isArray(Sanstha)
												? Sanstha.map(place => ({
														value: place?._id,
														label: toCamelCase(place?.name),
												  }))
												: []
										}
										onChange={opt => formik.setFieldValue('sanstha', opt?.value)}
										value={
											Array.isArray(Sanstha)
												? Sanstha.filter(option => option._id === formik?.values?.sanstha).map(
														option => ({
															value: option?._id,
															label: toCamelCase(option?.name),
														}),
												  )[0]
												: null
										}
										placeholder="Select Sanstha.."
									/>
								</div>
							</div>

							<div className="row">
								<div className="col-md-6">
									<label>
										Post Title <span className="text-danger">*</span>
									</label>
									<input
										type="text"
										name="title"
										className="form-control"
										value={formik.values.title}
										onChange={formik.handleChange}
										placeholder="Enter post title"
									/>
									{formik.touched.title && formik.errors.title && (
										<div className="text-danger">{formik.errors.title}</div>
									)}
								</div>

								<div className="col-md-6">
									<label>
										Post Description <span className="text-danger">*</span>
									</label>
									<Editor
										editorClassName="form-control"
										editorState={editorValues}
										onEditorStateChange={onEditorStateChange}
										onBlur={() => formik.setFieldTouched('description', true)}
										editorStyle={{ height: 300 }}
									/>
									{formik.touched.description && formik.errors.description && (
										<div className="text-danger">{formik.errors.description}</div>
									)}
								</div>
							</div>

							<div className="mb-3 col-md-6">
								<ImageUpload
									fieldName="file"
									value={formik.values.file}
									label="Media Upload *"
									uploadFunction={uploadSponsorImage}
									onChange={value => formik.setFieldValue('file', value.url)}
								/>
							</div>

							<div className="row mb-3">
								<div className="col-md-6">
									<label>
										Category <span className="text-danger">*</span>
									</label>
									<Select
										name="category"
										options={categoryOptions}
										onChange={opt => formik.setFieldValue('category', opt?.value)}
										value={categoryOptions.find(o => o.value === formik.values.category) || null}
										placeholder="Select category..."
									/>
									{formik.touched.category && formik.errors.category && (
										<div className="text-danger">{formik.errors.category}</div>
									)}
								</div>

								{formik.values.category === 'Other' && (
									<div className="col-md-6">
										<label>Specify Category</label>
										<input
											type="text"
											name="name"
											className="form-control"
											value={formik.values.name}
											onChange={formik.handleChange}
										/>
										{formik.touched.name && formik.errors.name && (
											<div className="text-danger">{formik.errors.name}</div>
										)}
									</div>
								)}
							</div>

							<div>
								<button type="submit" className="btn btn-success mr-2">
									<i className="fa fa-check me-1"></i>
									{id ? ' Update' : ' Create'}
								</button>
								<button
									type="button"
									className="btn btn-secondary"
									onClick={() => navigate('/post')}
								>
									<i className="fa fa-times me-1"></i> Cancel
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	)
}
export default NewPost
